import { render, staticRenderFns } from "./balance-trx-table.vue?vue&type=template&id=328b6f8f&"
import script from "./balance-trx-table.vue?vue&type=script&lang=js&"
export * from "./balance-trx-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports